import { GovernanceColors } from '@/config/governanceColors';
import { X } from 'lucide-react';

interface KeyboardHelpProps {
  open: boolean;
  onClose: () => void;
}

const SHORTCUTS = [
  { keys: 'Ctrl+Shift+K', action: 'Emergency kill switch (halt all agents)' },
  { keys: 'Ctrl+Shift+Q', action: 'Quick quarantine dialog' },
  { keys: 'Ctrl+Shift+F', action: 'Fleet status refresh' },
  { keys: 'Ctrl+Shift+1-8', action: 'Navigate to view 1-8' },
  { keys: 'Escape', action: 'Close any open modal or panel' },
  { keys: '?', action: 'Show this help overlay' },
];

export function KeyboardHelp({ open, onClose }: KeyboardHelpProps) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60"
      role="dialog"
      aria-modal="true"
      aria-labelledby="keyboard-help-title"
      data-testid="keyboard-help-overlay"
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div
        className="rounded-lg p-6 w-full max-w-md shadow-2xl border"
        style={{
          backgroundColor: GovernanceColors.surface,
          borderColor: '#374151',
        }}
      >
        <div className="flex items-center justify-between mb-4">
          <h3
            id="keyboard-help-title"
            className="text-lg font-semibold"
            style={{ color: GovernanceColors.text }}
          >
            Keyboard Shortcuts
          </h3>
          <button
            onClick={onClose}
            className="p-1 rounded hover:bg-[#3A352F] transition-colors"
            aria-label="Close"
          >
            <X className="w-4 h-4" style={{ color: GovernanceColors.textMuted }} />
          </button>
        </div>

        <table className="w-full text-sm">
          <tbody>
            {SHORTCUTS.map(({ keys, action }) => (
              <tr key={keys} className="border-b border-[#3A352F] last:border-0">
                <td className="py-2 pr-4">
                  <kbd
                    className="px-2 py-0.5 rounded text-xs font-mono"
                    style={{
                      backgroundColor: GovernanceColors.background,
                      color: GovernanceColors.primaryLight,
                      border: '1px solid #374151',
                    }}
                  >
                    {keys}
                  </kbd>
                </td>
                <td className="py-2" style={{ color: GovernanceColors.textMuted }}>
                  {action}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
